import {
  UserWeightField,
  FormDropDown,
  UserHeightField,
  UserShoeSizeField,
} from '../../forms/final-form-fields'
import { defineMessages, useIntl } from 'react-intl'
import get from 'lodash/get'

const messages = defineMessages({
  info: {
    id: 'profile.form.title.info',
    defaultMessage: 'Info for dive gear rental',
  },
  weight: {
    id: 'traveler.form.placeholder.weight',
    defaultMessage: 'Weight (kg)',
  },
  weightPounds: {
    id: 'traveler.form.placeholder.weightPounds',
    defaultMessage: 'Weight (pounds)',
  },
  height: {
    id: 'traveler.form.placeholder.height_cm',
    defaultMessage: 'Height (cm)',
  },
  heightFeets: {
    id: 'traveler.form.placeholder.heightFeets',
    defaultMessage: 'Height (feets)',
  },
  wetsuitSize: {
    id: 'traveler.form.placeholder.wetsuit.size',
    defaultMessage: 'Wetsuit size',
  },
  bcd: {
    id: 'traveler.form.placeholder.bcd',
    defaultMessage: 'BCD size',
  },
  insuranceTitle: {
    id: 'traveler.form.title.insurance',
    defaultMessage: 'Insurance',
  },
  insurance: {
    id: 'traveler.form.insurance',
    defaultMessage: 'Do you have a dive insurance?',
  },
  certificationNumber: {
    id: 'certificationNumber',
    defaultMessage: 'Certification Number',
  },
  insuranceCompany: {
    id: 'traveler.form.insuranceCompany',
    defaultMessage: 'Insurance company',
  },
  policy: {
    id: 'traveler.form.policy',
    defaultMessage: 'Policy number',
  },
  myopicDegree: {
    id: 'traveler.form.myopicDegree',
    defaultMessage: 'Myopic degree',
  },
  saveToProfile: {
    id: 'traveler.form.saveToProfile',
    defaultMessage: 'Save this information for future use',
  },
})

function RentalInfo({ field, values = {}, change }) {
  const intl = useIntl()
  const SIZES = window.info.account.SIZES
  const heightUnit = get(values, 'heightUnit', 10)
  const shoeSizeUnit = get(values, 'shoeSizeUnit', 10)
  return (
    <div className='dive-experience-form'>
      <p className='form-subtitle'>{intl.formatMessage(messages.info)}</p>
      <div className='form-row'>
        <UserHeightField
          inputName={`${field}.height`}
          dropdownName={`${field}.heightUnit`}
          heightUnit={heightUnit}
          change={change}
        />
        <UserWeightField
          inputName={`${field}.weight`}
          dropdownName={`${field}.weightUnit`}
        />
      </div>
      <div className='form-row'>
        <UserShoeSizeField
          dropdownName={`${field}.shoeSize`}
          sizeDropDownName={`${field}.shoeSizeUnit`}
          shoeSizeUnit={shoeSizeUnit}
        />
        <FormDropDown
          name={`${field}.wetsuitSize`}
          title={messages.wetsuitSize}
          isArrayCollection
          options={SIZES}
        />
      </div>
      <div className='form-row'>
        <FormDropDown
          name={`${field}.bcdSize`}
          title={messages.bcd}
          isArrayCollection
          options={SIZES}
        />
        {/* <FormCheckbox
          name={`${field}.saveToProfile`}
          label={messages.saveToProfile}
        /> */}
      </div>
    </div>
  )
}

export default RentalInfo
